import cl from 'classnames'
import styles from './Modal.module.scss'
import React, { memo, useEffect, useMemo, useState } from 'react'
import { Modal, ModalBackButton } from '@/components/Modal'
import { Form, Formik, useFormikContext } from 'formik'
import { Step1AdditionalAddressSchema, Step1AdditionalOkedSchema } from '@features/regulatoryInformation/Modal.schema'
import { useTranslation } from 'react-i18next'
import { AddAdditionalAddressForm } from '@features/occupationalRisks/AddAdditionalAddressForm'
import { AddAdditionalOkedForm } from '@features/occupationalRisks/AddAdditionalOkedForm'
import { handbookThunks } from '@/entity/handbook'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@/ui'


export const AddAdditionStep1 = memo(({
																				data,
																				onClose,
																				onSubmit,
																			}) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const { okeds, equipment } = useSelector((state) => ({
		okeds: state.handbook.okeds,
		equipment: state.equipment1.oneEquipment,
	}))

	useEffect(() => {
		if (!okeds?.length > 0) dispatch(handbookThunks.getOkeds())
	}, [])

	const blocks = [
		{
			key: 'address',
			node: <AddAdditionalAddressForm data={data}/>,
			title: 'occupational_risks_assessment.steps.step_1.set_address',
			schema: Step1AdditionalAddressSchema,
			initialState: {
				ddistrictCode: data?.item?.ddistrictCode,
				dregionCode: data?.item?.dregionCode,
				dlocalityCode: data?.item?.dlocalityCode,
				addressKz: data?.item?.addressKz,
				address: data?.item?.address,
			}
		},
		{
			key: 'oked',
			node: <AddAdditionalOkedForm />,
			title: 'occupational_risks_assessment.steps.step_1.set_oked',
			schema: Step1AdditionalOkedSchema,
			initialState: {
				okedCode: data?.item?.oked?.code,
			}
		},
	]

	const render = useMemo(() => {
		return blocks.map(b =>
			data?.type?.[b.key] ? b : null,
		)?.find(a => a)
	}, [])

	const handleSubmit = (res) => {
		let body
		if (render?.key === 'address') {
			body = {
				kato: res?.dlocalityCode || res?.dregionCode,
				ddistrictCode: res?.ddistrictCode,
				dregionCode: res?.dregionCode,
				dlocalityCode: res?.dlocalityCode,
				address: res?.address,
				addressKz: res?.addressKz,
			}
		} else {
			let findOked = okeds?.find(i => i.code === res?.okedCode)
			body = {
				oked: {
					nameRu: findOked?.rus,
					nameKz: findOked?.kz,
					code: findOked?.code,
				},
			}
		}

		let array = equipment?.data?.orgs?.map(i => {
			if (i.externalId === data?.item?.externalId) {
				return {
					...i,
					...body,
				}
			} else {
				return i
			}
		})

		let objectRes = {
			orgs: array,
		}

		onSubmit(objectRes)
	}

	return (
		<Modal windowClassName={cl(styles.modal_wrapper, styles.modal_wrapperSizeM)}>
			<ModalBackButton onClick={onClose} />

			<h4 className={cl('mb-4')}>
				{t(render?.title)}
			</h4>

			<div className={cl(styles.wrapper, 'scroll')}>
				<Formik
					initialValues={render?.initialState}
					onSubmit={handleSubmit}
					enableReinitialize={true}
					validationSchema={render?.schema}
				>
					{({ values, errors }) => {
						return (
							<Form>
								{render?.node}

								<div className={cl('flex', 'justify-content-end', 'gap-4', 'mt-4')}>
									<Button type="bare" onClick={onClose}>
										{t('cancel')}
									</Button>

									<Button type="submit">
										{t('add')}
									</Button>
								</div>
							</Form>
						)
					}}
				</Formik>
			</div>
		</Modal>
	)
})